export const DOCUMENTS_TEXT = Object.freeze({
  common: {
    emptyValue: '-',
    blankValue: '',
    noValidity: 'Sin vigencia',
  },
  confirmDelete: {
    title: 'Eliminar documento',
    subtitle: 'Esta acción no se puede deshacer.',
    confirm: 'Eliminar',
    cancel: 'Cancelar',
    messageByName: (name) => `¿Deseas eliminar el documento "${name}"?`,
    messageDefault: '¿Deseas eliminar este documento?',
  },
  tableCard: {
    buttons: {
      downloadAll: 'Todos',
      create: 'Documento',
    },
    table: {
      headers: {
        index: '#',
        name: 'Nombre',
        validity: 'Vigencia',
        comments: 'Comentarios',
      },
      loading: 'Cargando documentos...',
      empty: 'Sin documentos registrados.',
      validityStart: 'Inicio:',
      validityEnd: 'Fin:',
      actionTitles: {
        download: 'Descargar documento',
        edit: 'Editar documento',
        delete: 'Eliminar documento',
      },
    },
  },
  legalFileCard: {
    title: 'Expediente',
    empty: 'No se ha configurado ningún expediente.',
    status: {
      complete: 'COMPLETO',
      incomplete: 'INCOMPLETO',
    },
    noAssignedDocument: '',
    buttons: {
      assign: 'Asignar',
    },
    actionTitles: {
      download: 'Descargar documento',
      edit: 'Editar documento',
      add: 'Agregar documento',
      assign: 'Asignar documento',
      delete: 'Eliminar archivo',
    },
    reportButton: 'Expediente',
  },
  createModal: {
    titleCreate: 'Nuevo documento',
    titleEdit: 'Editar documento',
    subtitleCreate: 'Captura la información del documento para el expediente.',
    subtitleEdit: 'Actualiza la información del documento seleccionado.',
    closeAriaLabel: 'Cerrar modal',
    labels: {
      name: 'Nombre *',
      record: 'Expediente',
      source: 'Origen del documento *',
      file: 'Archivo *',
      url: 'URL *',
      validityStart: 'Vigencia fecha inicio',
      validityEnd: 'Vigencia fecha fin',
      comments: 'Comentarios',
    },
    sourceOptions: {
      file: 'Archivo',
      url: 'URL',
    },
    placeholders: {
      name: 'Ej. Contrato de prestación de servicios',
      url: 'https://...',
      date: 'Selecciona fecha',
      comments: 'Agrega observaciones del documento',
      noFileSelected: 'Ningún archivo seleccionado',
      currentFile: 'Archivo actual',
    },
    buttons: {
      selectFile: 'Seleccionar archivo',
      cancel: 'Cancelar',
      save: 'Guardar',
    },
    validation: {
      nameRequired: 'Captura el nombre del documento.',
      fileRequired: 'Selecciona un archivo para continuar.',
      urlRequired: 'Captura una URL para continuar.',
      startDateAfterEnd: 'La fecha de inicio no puede ser mayor a la fecha fin.',
      endDateBeforeStart: 'La fecha fin no puede ser menor a la fecha de inicio.',
    },
  },
  toasts: {
    loadCustomerError: 'No fue posible cargar los documentos del cliente.',
    loadSupplierError: 'No fue posible cargar los documentos del proveedor.',
    loadSaleError: 'No fue posible cargar los documentos del negocio.',
    downloadStarted: 'Descarga iniciada correctamente.',
    noDocumentsToDownload: 'No hay documentos para descargar.',
    noDownloadableFile: 'Este documento no tiene archivo descargable.',
    deleteSuccess: 'Documento eliminado correctamente.',
    deleteError: 'No fue posible eliminar el documento.',
    saveError: 'No fue posible guardar el documento.',
    updateError: 'No fue posible actualizar el documento.',
    saveSuccess: 'Documento guardado correctamente.',
    updateSuccess: 'Documento actualizado correctamente.',
  },
  download: {
    customerPrefix: 'documentos',
    supplierPrefix: 'documentos',
    salePrefix: 'documentos_negocio',
    legalFilePrefix: 'expediente',
    customerFallbackNameSegment: 'CLIENTE',
    supplierFallbackNameSegment: 'PROVEEDOR',
    saleFallbackNameSegment: 'NEGOCIO',
  },
});
